export default "__VITE_ASSET__IeJR1k2e__"